import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "task-card" }
const _hoisted_2 = ["src", "srcset"]
const _hoisted_3 = { class: "task-card__info" }
const _hoisted_4 = { class: "task-card__name" }
const _hoisted_5 = {
  key: 0,
  class: "task-card__nano"
}
const _hoisted_6 = { class: "task-card__nano" }

import { computed } from 'vue'
import router from '@/router'
import { isNumber } from '@/common/helpers'

// Types
import { Props } from '@/components/TaskCard'

// Components
import Button from '@/components/ui/Button'
import IconedText from '@/components/ui/IconedText'
import Money from '@/components/ui/Money'
import Badge from '@/components/ui/Badge'
import Conditions from '@/components/Conditions'

// Props
import { useI18n } from 'vue-i18n'
import { IdType } from '@/common/types'
import { StatusType } from '@/components/TaskSlider'

export default /*#__PURE__*/_defineComponent({
  __name: 'TaskCard',
  props: {
    item: {},
    routeName: {}
  },
  setup(__props: any) {

const props = __props

// i18n
const { t } = useI18n()

// Computed
const srcSet = computed<string | null>(() => {
  if (!props.item.img) {
    return null
  }
  let result = `${props.item.img.x1} 1x`
  if (props.item.img.x2) {
    result += `, ${props.item.img.x2} 2x`
  }
  if (props.item.img.x3) {
    result += `, ${props.item.img.x3} 3x`
  }
  return result
})

const status = computed<StatusType>(() => props.item?.status ?? 'new')

const buttonText = computed<string | null>(() => {
  if (!Boolean(['awaitReview', 'error', 'new'].includes(status.value))) {
    return t('taskCard.button.default')
  }
  return t('taskCard.button.' + status.value)
})
const showBadge = computed<boolean>(() => Boolean(props.item.status && status.value !== 'new'))

const priceText = computed<string>(() => props.item.price_text?.length ? props.item.price_text : t('taskCard.price'))

function gotoTask(id: IdType): void {
  router.push({name: 'Task', params: {id}})
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("picture", null, [
      (_ctx.item.img)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.item.img.x1,
            srcset: srcSet.value
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    (showBadge.value)
      ? (_openBlock(), _createBlock(_unref(Badge), {
          key: 0,
          class: "task-card__badge",
          status: status.value
        }, null, 8, ["status"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.item.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " #" + _toDisplayString(_ctx.item.id), 1))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.item.name), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(priceText.value) + ":", 1),
        _createVNode(_unref(Money), {
          class: "task-card__price",
          money: _ctx.item.price
        }, null, 8, ["money"])
      ]),
      _createVNode(_unref(Conditions), {
        conditions: _ctx.item.conditions
      }, null, 8, ["conditions"]),
      _createVNode(_unref(Button), {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (gotoTask(_ctx.item.id)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(buttonText.value), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})